
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.646 4.854a.5.5 0 00.708 0l3.182-3.182a.5.5 0 10-.708-.708L4 3.793 1.172.964a.5.5 0 10-.708.708l3.182 3.182zM3.5 4v.5h1V4h-1z","fill":"#9DD6FF"}})])
          )
        }
      }
    